import { useTranslation } from 'react-i18next'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import IconButton from '@mui/material/IconButton'
import { alpha, useTheme } from '@mui/material/styles'
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'

const TablePagination = ({
  page = 1,
  size = 5,
  totalPages = 1,
  total = 0,
  onPageChange = (...args) => {},
  onSizeChange = (...args) => {},
}) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const handleSizeChange = (event) => {
    const newSize = parseInt(event.target.value, 10)
    onSizeChange(newSize)
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: 'center',
        justifyContent: 'space-between',
        p: 2,
        borderTop: `1px solid ${theme.palette.divider}`,
        bgcolor:
          theme.palette.mode === 'dark'
            ? alpha(theme.palette.common.white, 0.03)
            : '#f5f5f5',
        borderBottomLeftRadius: 4,
        borderBottomRightRadius: 4
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', mb: { xs: 2, sm: 0 } }}>
        <Typography variant="body2" sx={{ mr: 1 }}>
          {t('rows_per_page')}
        </Typography>
        <Select
          value={size}
          onChange={handleSizeChange}
          variant="outlined"
          size="small"
          sx={{
            minWidth: 80,
            backgroundColor:
              theme.palette.mode === 'dark'
                ? alpha(theme.palette.common.white, 0.03)
                : theme.palette.background.paper
          }}
        >
          <MenuItem value={10}>10</MenuItem>
          <MenuItem value={25}>25</MenuItem>
          <MenuItem value={50}>50</MenuItem>
        </Select>
      </Box>

      {/* Навигация */}
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <IconButton
          onClick={() => onPageChange(Math.max(1, page - 1))}
          disabled={page <= 1}
          size="small"
          sx={{ mx: 1 }}
        >
          <KeyboardArrowLeftIcon />
        </IconButton>

        <Typography variant="body2">
          {page} {t('of')} {totalPages || 1}
        </Typography>

        <IconButton
          onClick={() => onPageChange(Math.min(totalPages || 1, page + 1))}
          disabled={page >= totalPages}
          size="small"
          sx={{ mx: 1 }}
        >
          <KeyboardArrowRightIcon />
        </IconButton>
      </Box>

      {/* Всего записей */}
      <Typography variant="body2" sx={{ mt: { xs: 2, sm: 0 } }}>
        {t('total')}: {total || 0} {t('records')}
      </Typography>
    </Box>
  )
}

export default TablePagination
